export const Newsletter = () => {
	$('#mc-newsletter-form, #cyber-newsletter-form, #cyber-v2-newsletter-form').on('submit', (e) => {
		e.preventDefault();

		let validRegex =
			/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

		let email = $('.signup-form #email').val();
		let referring_site = process.env.MIX_BASE_URL;
		let formId = e.target.id;

		if (email.match(validRegex)) {
			console.log(formId);
			
			const url = new URL('/wp-json/api/v1/newsletter', process.env.MIX_BASE_URL);
			
			fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					email: email,
					referring_site: referring_site,
					formId: formId,
				}),
			})
			.then(response => response.json())
			.then(result => {
				if (result.status === 'success') {
					$('.signup-form #email').parent().removeClass('invalid');
					$('.signup-form #email').parent().addClass('success');
				} else {
					showError('Error: Please try again later');
					console.log(result);
				}
			})
			.catch(error => {
				showError('Error: Please try again later');
				console.log(error);
			});
		} else {
			showError('Invalid email address');
		}
	});
};

const showError = (msg) => {
	let $field = $('.signup-form #email');
	$field.parent().addClass('invalid');
	$field.parent().removeClass('success');
	$field.val('');
	$field.attr('placeholder', msg);
};
